export default __webpack_public_path__ + "static/media/designing.png.webp";